import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Step from './views/Step.vue';
import Thanks from './components/steps/Thanks.vue';
import ErrorPage from './views/Error.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '*/step/:step',
      name: 'step',
      component: Step,
    },
    {
      path: '*/step/:step/error',
      name: 'error',
      component: ErrorPage,
    },
    {
      path: '*/step/success/:employment/:degree',
      name: 'thanks',
      component: Thanks,
    },
    {
      path: '*/step/success/:employment/',
      name: 'thanks',
      component: Thanks,
    },
    {
      path: '*/step/:step/*',
      name: 'step',
      component: Step,
    },
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

